export const en = {
    cancel: 'Cancel',
    description: 'Product description',
    save: 'Save'
};
